import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'
import MechanicsPanel from '@/components/MechanicsPanel'
import SignIn from '@/components/SignIn'
import MyAccount from '@/components/Profile/MyAccount'
import MyAccountRepresentative from "@/components/Profile/MyAccountRepresentative";
import MyDocumentsRepresentative from "../components/Profile/MyDocumentsRepresentative";
import GarantieMoto from '@/components/Garantie/GarantieMoto'
import GarantieMotos from '@/components/Garantie/GarantieMotos'
import GarantieMotoView from '@/components/Garantie/GarantieMotoView'
import GarantieMotosView from '@/components/Garantie/GarantieMotosView'
import AssuranceTemporaire from '@/components/Garantie/AssuranceTemporaire'
import NotFound from '@/components/Errors/NotFound'
import GarantieAuto from '@/components/Garantie/GarantieAuto';
import GarantieAutos from '@/components/Garantie/GarantieAutos';
import GarantiesAuto from '@/components/Garantie/GarantiesAuto';
import GarantieAutoView from '@/components/Garantie/GarantieAutoView';
import GarantieAutosView from '@/components/Garantie/GarantieAutosView';
import GarantiesAutoView from '@/components/Garantie/GarantiesAutoView';
import GarantieCampingCar from '@/components/Garantie/GarantieCampingCar'
import GarantieCampingCars from '@/components/Garantie/GarantieCampingCars'
import GarantieCampingCarView from '@/components/Garantie/GarantieCampingCarView'
import GarantieCampingCarsView from '@/components/Garantie/GarantieCampingCarsView'
import PanneMecanique from '@/components/Garantie/PanneMecanique';
import PanneMecaniqueGarantie from '@/components/Garantie/PanneMecaniqueGarantie';
import GarantieOutilsJardin from '@/components/Garantie/GarantieOutilsJardin';
import GarantieOutilsJardinView from '@/components/Garantie/GarantieOutilsJardinView';
import Thanks from '@/components/Garantie/Thanks'
import Clients from '@/components/Clients/Clients'
import EditClient from '@/components/Clients/EditClient'
import GarantiesList from '@/components/GarantiesSouscrites/GarantiesList'

import Factures from '@/components/Factures/Factures'
import Commissions from '@/components/Commissions/Commissions'
import CommissionsMensuelles from '@/components/Commissions/CommissionsMensuelles'

import Devis from '@/components/Devis/Devis'
import MechanicSide from '@/components/MechanicSide'
import PlanDinteressement from '@/components/PlanDinteressement/PlanDinteressement'

import DrivingSchoolSide from '@/components/DrivingSchool/DrivingSchoolSide'
import DrivingSchoolDashboard from '@/components/DrivingSchool/Dashboard/Dashboard'
import DrivingLicenceAttestation from '@/components/DrivingSchool/DrivingLicenceAttestation/DrivingLicenceAttestation'
import DrivingLicenceAttestationView from '@/components/DrivingSchool/DrivingLicenceAttestation/DrivingLicenceAttestationView'
import DrivingSchoolAttestationThanksPage from '@/components/DrivingSchool/DrivingLicenceAttestation/DrivingSchoolAttestationThanksPage'
import DrivingSchoolMyAccount from '@/components/DrivingSchool/Profile/DrivingSchoolMyAccount'

import { DRIVING_SCHOOOL_CONST } from "@/driving_school_consts";
import DealerInsuranceCampingCar from "../components/Garantie/DealerInsuranceCampingCar/DealerInsuranceCampingCar";
import DealerInsuranceCampingCarView from "../components/Garantie/DealerInsuranceCampingCar/DealerInsuranceCampingCarView";
import GarantiesImport from "../components/Garantie/Import/GarantiesImport";
import BrokerAssistanceAutocar from "../components/Garantie/BrokerAssistance/BrokerAssistanceAutocar";
import BrokerAssistanceAutocarSouscription from "../components/Garantie/BrokerAssistance/BrokerAssistanceAutocarSouscription";
import BrokerAssistanceAutocarView from "../components/Garantie/BrokerAssistance/BrokerAssistanceAutocarView";
import BrokerAssistancePoidsLourds from "../components/Garantie/BrokerAssistance/BrokerAssistancePoidsLourds";
import BrokerAssistancePoidsLourdsView from "../components/Garantie/BrokerAssistance/BrokerAssistancePoidsLourdsView";
import BrokerAssistancePoidsLourdsSouscription from "../components/Garantie/BrokerAssistance/BrokerAssistancePoidsLourdsSouscription";
import BrokerAssistanceVSL from "../components/Garantie/BrokerAssistance/BrokerAssistanceVSL";
import BrokerAssistanceVSLView from "../components/Garantie/BrokerAssistance/BrokerAssistanceVSLView";
import BrokerAssistanceVSLSouscription from "../components/Garantie/BrokerAssistance/BrokerAssistanceVSLSouscription";
import BrokerAssistanceVUVL from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUVL";
import BrokerAssistanceVUVLView from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUVLView";
import BrokerAssistanceVUVLSouscription from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUVLSouscription";
import BrokerAssistanceVUL4097 from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUL4097";
import BrokerAssistanceVUL4097View from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUL4097View";
import BrokerAssistanceVUL4097Souscription from "../components/Garantie/BrokerAssistance/BrokerAssistanceVUL4097Souscription";
import AdvanceStats from "../components/Statistics/AdvanceStats";
import KBISImport from "../components/Documents/KBISImport";
import ORIASImport from "../components/Documents/ORIASImport";
import RCImport from "../components/Documents/RCImport";
import RIBImport from "../components/Documents/RIBImport";
import DevisEnLigneAssurance from "../components/Garantie/DealerInsuranceCampingCar/DevisEnLigneAssurance";
import DevisEnLigneAssuranceView from "../components/Garantie/DealerInsuranceCampingCar/DevisEnLigneAssuranceView";
import DevisInsurances from "../components/Devis/DevisInsurances";
import AssurancesGarantiesList from "../components/GarantiesSouscrites/AssurancesGarantiesList";
import ClientDocuments from "../components/Clients/ClientDocuments";
import SignedMembershipImport from "@/components/Clients/Documents/SignedMembershipImport";
import GrayCardImport from "../components/Clients/Documents/GrayCardImport";
import DriverLicenseImport from "../components/Clients/Documents/DriverLicenseImport";
import InformationReportImport from "../components/Clients/Documents/InformationReportImport";
import BankDetailsImport from "../components/Clients/Documents/BankDetailsImport";
import MaintenanceInvoicesImport from "../components/Clients/Documents/MaintenanceInvoicesImport";
import KbisImport from "../components/Clients/Documents/KbisImport";
import OwnerIDImport from "../components/Clients/Documents/OwnerIDImport";
import DevisAssistance from '../components/Devis/DevisAssistance';
import GarantiesAssistanceList from '../components/GarantiesSouscrites/GarantiesAssistanceList';
import AssistancesList from '../components/GarantiesSouscrites/AssistancesList';
import AssistancesDetails from '../components/GarantiesSouscrites/AssistancesDetails';
import ClientsAssistance from '../components/Clients/ClientsAssistance';
import AdvanceStatsAssistance from "../components/Statistics/AdvanceStatsAssistance";
import AdvanceStatsAssistances from "../components/Statistics/AdvanceStatsAssistances";
import Documentations from '../components/Documentations/Documentations';
import GarantieAutoMensualisee from '../components/Garantie/GarantieAutoMensualisee';
import GarantieAutoMensualiseeView from '../components/Garantie/GarantieAutoMensualiseeView';
import RepresentativeCommission from '../components/Representative/Commission/RepresentativeCommission.vue';
import BordereauxReversement from '../components/Representative/BordeauxReversement.vue';

// Redesign v2 Routes
import GarantieMotoV2 from "@/components/Garantie/moto/GarantieMoto";
import GarantieMotoV2View from "@/components/Garantie/moto/GarantieMotoView";
import GarantieAutoV2 from "@/components/Garantie/auto/GarantieAuto";
import GarantieAutoV2View from "@/components/Garantie/auto/GarantieAutoView";
import GarantieCampingCarV2 from "@/components/Garantie/camping-car/GarantieCampingCar";
import GarantieCampingCarV2View from "@/components/Garantie/camping-car/GarantieCampingCarView";
import GarantieAutoMensualiseeV2 from "@/components/Garantie/auto-mensualisee/GarantieAutoMensualisee";
import GarantieAutoMensualiseeV2View from "@/components/Garantie/auto-mensualisee/GarantieAutoMensualiseeView";


Vue.use(Router);


export default new Router({
    mode: 'history',
    routes: [
        { path: '/signin/:token', component: SignIn },
        //Mechanic Routes
        {
            path: '/',
            component: MechanicSide,
            children: [
                { path: '/', component: MechanicsPanel },
                { path: '/my-account', component: MyAccount },
                { path: '/my-account-representative', component: MyAccountRepresentative },
                { path: '/bordereaux-reversement', component: BordereauxReversement },
                { path: '/garantie-moto', component: GarantieMoto },
                { path: '/garantie-moto/:id', component: GarantieMoto },
                { path: '/garantie-moto-view/:id', component: GarantieMotoView },
                { path: '/garantie-motos', component: GarantieMotos },
                { path: '/garantie-motos/:id', component: GarantieMotos },
                { path: '/garantie-motos-view/:id', component: GarantieMotosView },
                { path: '/assurance-temporaire', component: AssuranceTemporaire },
                { path: '/garantie-auto', component: GarantieAuto },
                { path: '/garantie-auto/:id', component: GarantieAuto },
                { path: '/garantie-auto-view/:id', component: GarantieAutoView },
                { path: '/garantie-autos', component: GarantieAutos },
                { path: '/garantie-autos/:id', component: GarantieAutos },
                { path: '/garantie-autos-view/:id', component: GarantieAutosView },

                // Redesign v2 Routes
                { path: '/garantie-moto-v2', component: GarantieMotoV2 },
                { path: '/garantie-moto-v2/:id', component: GarantieMotoV2 },
                { path: '/garantie-moto-v2-view/:id', component: GarantieMotoV2View },

                { path: '/garantie-auto-v2', component: GarantieAutoV2 },
                { path: '/garantie-auto-v2/:id', component: GarantieAutoV2 },
                { path: '/garantie-auto-v2-view/:id', component: GarantieAutoV2View },

                { path: '/garantie-camping-car-v2', component: GarantieCampingCarV2 },
                { path: '/garantie-camping-car-v2/:id', component: GarantieCampingCarV2 },
                { path: '/garantie-camping-car-v2-view/:id', component: GarantieCampingCarV2View },

                { path: '/garantie-auto-mensualisee-v2', component: GarantieAutoMensualiseeV2 },
                { path: '/garantie-auto-mensualisee-v2/:id', component: GarantieAutoMensualiseeV2 },
                { path: '/garantie-auto-mensualisee-v2-view/:id', component: GarantieAutoMensualiseeV2View },
                // End Redesign v2 Routes

                { path: '/garanties-auto', component: GarantiesAuto },
                { path: '/garanties-auto/:id', component: GarantiesAuto },
                { path: '/garanties-auto-view/:id', component: GarantiesAutoView },
                { path: '/garantie-camping-car', component: GarantieCampingCar },
                { path: '/garantie-camping-car/:id', component: GarantieCampingCar },
                { path: '/garantie-camping-car-view/:id', component: GarantieCampingCarView },
                { path: '/garantie-camping-cars', component: GarantieCampingCars },
                { path: '/garantie-camping-cars/:id', component: GarantieCampingCars },
                { path: '/garantie-camping-cars-view/:id', component: GarantieCampingCarsView },
                { path: '/garantie-camping-car-dealer', component: DealerInsuranceCampingCar },
                { path: '/garantie-camping-car-dealer/:id', component: DealerInsuranceCampingCar },
                { path: '/garantie-camping-car-dealer-view/:id', component: DealerInsuranceCampingCarView },
                { path: '/devis-en-ligne-assurance', component: DevisEnLigneAssurance },
                { path: '/devis-en-ligne-assurance/:id', component: DevisEnLigneAssurance },
                { path: '/devis-en-ligne-assurance-view/:id', component: DevisEnLigneAssuranceView },
                { path: '/panne-mecanique', component: PanneMecanique },
                { path: '/panne-mecanique-garantie/:id', component: PanneMecaniqueGarantie },
                { path: '/garantie-import', component: GarantiesImport },
                { path: '/assistance-autocars', component: BrokerAssistanceAutocar },
                { path: '/assistance-autocars/:id', component: BrokerAssistanceAutocar },
                { path: '/assistance-autocars-view/:id', component: BrokerAssistanceAutocarView },
                { path: '/assistance-autocars-souscription/:id', component: BrokerAssistanceAutocarSouscription },
                { path: '/assistance-poids-lourds', component: BrokerAssistancePoidsLourds },
                { path: '/assistance-poids-lourds/:id', component: BrokerAssistancePoidsLourds },
                { path: '/assistance-poids-lourds-view/:id', component: BrokerAssistancePoidsLourdsView },
                { path: '/assistance-poids-lourds-souscription/:id', component: BrokerAssistancePoidsLourdsSouscription },
                { path: '/assistance-vsl', component: BrokerAssistanceVSL },
                { path: '/assistance-vsl/:id', component: BrokerAssistanceVSL },
                { path: '/assistance-vsl-view/:id', component: BrokerAssistanceVSLView },
                { path: '/assistance-vsl-souscription/:id', component: BrokerAssistanceVSLSouscription },
                { path: '/assistance-vu-vl', component: BrokerAssistanceVUVL },
                { path: '/assistance-vu-vl/:id', component: BrokerAssistanceVUVL },
                { path: '/assistance-vu-vl-view/:id', component: BrokerAssistanceVUVLView },
                { path: '/assistance-vu-vl-souscription/:id', component: BrokerAssistanceVUVLSouscription },
                { path: '/assistance-vul4097', component: BrokerAssistanceVUL4097 },
                { path: '/assistance-vul4097/:id', component: BrokerAssistanceVUL4097 },
                { path: '/assistance-vul4097-view/:id', component: BrokerAssistanceVUL4097View },
                { path: '/assistance-vul4097-souscription/:id', component: BrokerAssistanceVUL4097Souscription },
                { path: '/garantie-outils-jardin', component: GarantieOutilsJardin },
                { path: '/garantie-outils-jardin/:id', component: GarantieOutilsJardin },
                { path: '/garantie-outils-jardin-view/:id', component: GarantieOutilsJardinView },
                { path: '/clients', component: Clients },
                { path: '/client/:id', component: EditClient },
                { path: '/client/:id/documents', component: ClientDocuments },
                { path: '/clients-assistance', component: ClientsAssistance },
                { path: '/signed-membership-import/:id', component: SignedMembershipImport },
                { path: '/gray-card-import/:id', component: GrayCardImport },
                { path: '/driver-license-import/:id', component: DriverLicenseImport },
                { path: '/information-report-import/:id', component: InformationReportImport },
                { path: '/bank-details/:id', component: BankDetailsImport },
                { path: '/maintenance-invoices/:id', component: MaintenanceInvoicesImport },
                { path: '/kbis/:id', component: KbisImport },
                { path: '/owner-id/:id', component: OwnerIDImport },
                { path: '/garantie-souscrites', component: GarantiesList },
                { path: '/assistances-souscrites', component: GarantiesAssistanceList },
                { path: '/assistances-souscrite', component: AssistancesList },
                { path: '/assistances-souscrite/:id', component: AssistancesDetails },
                { path: '/factures', component: Factures },
                { path: '/plan-dinteressement', component: PlanDinteressement },
                { path: '/commissions', component: Commissions },
                { path: '/commissions-mensuelles', component: CommissionsMensuelles },
                { path: '/devis', component: Devis },
                { path: '/devis-assistance', component: DevisAssistance },
                { path: '/devis-insurances', component: DevisInsurances },
                { path: '/devis-insurances-souscrites', component: AssurancesGarantiesList },
                { path: '/stats', component: AdvanceStats },
                { path: '/stats-assistance', component: AdvanceStatsAssistance },
                { path: '/stats-assistances', component: AdvanceStatsAssistances },
                { path: '/merci', component: Thanks },
                { path: '/my-documents', component: MyDocumentsRepresentative },
                { path: '/kbis-import', component: KBISImport },
                { path: '/orias-import', component: ORIASImport },
                { path: '/rc-import', component: RCImport },
                { path: '/rib-import', component: RIBImport },
                { path: '/documentations', component: Documentations },
                { path: '/garantie-auto-mensualisee', component: GarantieAutoMensualisee },
                { path: '/garantie-auto-mensualisee/:id', component: GarantieAutoMensualisee },
                { path: '/garantie-auto-mensualisee-view/:id', component: GarantieAutoMensualiseeView },
                {
                    path: '/representative-commission',
                    component: RepresentativeCommission,
                    beforeEnter: (to, from, next) => {
                        if (store.getters.isDental) {
                            next('/');
                        } else {
                            next();
                        }
                    }
                }

            ],
            beforeEnter: (to, from, next) => { console.log('mechanic_route'); next() }
        },
        //Driving school routes
        {
            path: '/double_commande',
            component: DrivingSchoolSide,
            children: [
                { path: '/double_commande', component: DrivingSchoolDashboard },

                {
                    path: '/double_commande/double_commande_attestation',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY }
                },
                {
                    path: '/double_commande/double_commande_attestation/:id',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY }
                },
                {
                    path: '/double_commande/double_commande_attestation_view/:id',
                    component: DrivingLicenceAttestationView,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY },
                    beforeEnter: (to, from, next) => {
                        setRouteTitle(DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.PAGE_TITLE);
                        next();
                    }
                },

                {
                    path: '/double_commande/vtc_attestation',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY }
                },
                {
                    path: '/double_commande/vtc_attestation/:id',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY }
                },
                {
                    path: '/double_commande/vtc_attestation_view/:id',
                    component: DrivingLicenceAttestationView,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY },
                    beforeEnter: (to, from, next) => {
                        setRouteTitle(DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.PAGE_TITLE);
                        next();
                    }
                },

                {
                    path: '/double_commande/bepecaser_attestation',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY }
                },
                {
                    path: '/double_commande/bepecaser_attestation/:id',
                    component: DrivingLicenceAttestation,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY }
                },
                {
                    path: '/double_commande/bepecaser_attestation_view/:id',
                    component: DrivingLicenceAttestationView,
                    props: { attestation_type: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY },
                    beforeEnter: (to, from, next) => {
                        setRouteTitle(DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.PAGE_TITLE);
                        next();
                    }
                },
                { path: '/double_commande/merci', component: DrivingSchoolAttestationThanksPage },
                { path: '/double_commande/mon-compte', component: DrivingSchoolMyAccount },
            ],
            beforeEnter: (to, from, next) => { console.log('driving_school_route'); next() }
        },

        { path: '/404', name: '404', component: NotFound, },
        { path: '*', redirect: '/404' }
    ]
})

const setRouteTitle = (title) => {
    document.title = title;
};



// WEBPACK FOOTER //
// ./src/router/index.js